import { Cog, Recycle, Plane, Users, Wrench, ShieldCheck, Truck, Package, Building2 } from "lucide-react";
import { DIFFERENTIALS } from "@/lib/brand";

const ICONS = [Cog, Recycle, Plane, Users, Wrench, ShieldCheck, Truck, Package, Building2];

export const Differentials = () => {
  return (
    <section
      id="diferenciais"
      data-testid="differentials-section"
      className="relative py-24 lg:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-14">
          <div className="max-w-2xl">
            <div className="flex items-center gap-3 mb-5 reveal">
              <span className="divider-gold" />
              <span className="tracking-eyebrow text-gold">Diferenciais</span>
            </div>
            <h2
              className="font-display text-4xl lg:text-5xl font-bold text-navy leading-[1.05] tracking-[-0.025em] reveal"
              data-testid="differentials-title"
            >
              Empresas não param
              <br />
              por acaso.
            </h2>
          </div>
          <p className="max-w-md text-lg text-slate-600 leading-relaxed reveal">
            Cada característica da Imporparts foi construída para uma única finalidade:
            manter sua produção rodando.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {DIFFERENTIALS.map((d, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <div
                key={d.title}
                className="reveal card-lift group relative rounded-2xl border border-slate-200 bg-white p-8 overflow-hidden"
                data-testid={`differential-card-${i}`}
                style={{ transitionDelay: `${i * 70}ms` }}
              >
                <div
                  className="absolute -top-16 -right-16 w-40 h-40 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-500"
                  style={{ background: "radial-gradient(closest-side, rgba(184,134,58,0.25), transparent)" }}
                  aria-hidden
                />
                <div className="w-12 h-12 rounded-xl bg-navy text-white flex items-center justify-center mb-6 group-hover:bg-gold transition-colors">
                  <Icon className="w-5 h-5" />
                </div>
                <div className="font-display text-2xl font-semibold text-navy mb-3">
                  {d.title}
                </div>
                <p className="text-slate-600 leading-relaxed">{d.desc}</p>

                <div className="mt-6 h-px w-full bg-gradient-to-r from-slate-200 to-transparent" />
                <div className="mt-4 text-xs tracking-[0.22em] uppercase font-semibold text-slate-400 group-hover:text-gold transition-colors">
                  0{i + 1} · Continuidade
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
